import Box from '@material-ui/core/Box';
import React from 'react';

const Page404: React.FC = () => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
  >
    <h1>404 Not found</h1>
    <span>Oops!</span>
  </Box>
);

export default Page404;
